.bam-interferer {
  display: flex;
  margin-top: 1rem;

  @include desktop() {
    margin-top: -6rem;
    position: relative;
  }

  &.custom-margin-bottom {
    margin-bottom: 5rem;

    @include tablet() {
      margin-bottom: 7rem;
    }

    @include desktop() {
      justify-content: flex-end;
      margin-bottom: 3rem;
    }

    &.bam-interferer--is-image {
      margin-bottom: 2rem;

      @include tablet() {
        margin-bottom: 2rem;
      }
    }
  }

  &--is-green .bam-interferer__background {
    background-color: var(--bal-color-green-3);
  }
  &--is-purple .bam-interferer__background {
    background-color: var(--bal-color-purple-3);
  }
  &--is-red .bam-interferer__background {
    background-color: var(--bal-color-red-3);
  }
  &--is-yellow .bam-interferer__background {
    background-color: var(--bal-color-yellow-3);
  }

  .bam-interferer__content-wrapper {
    display: grid;
    width: 100%;

    @include desktop() {
      width: 50%;
      max-width: 600px;
      overflow: hidden;
      border-radius: 12px 0 0 12px;
    }

    @include from(1464px) {
      width: 45%;
      border-radius: 12px;
      margin-right: calc((100vw - 1400px) / 2);
    }

    & > bal-heading {
      max-width: 320px;
    }

    bal-button {
      width: 100%;

      & > * {
        width: 100%;
      }

      @include tablet() {
        width: auto;
        margin-right: 1rem;

        & > * {
          width: auto;
        }
      }
    }

    .bam-interferer__background {
      height: 100%;
      width: 100%;
      grid-area: 1/-1;
      z-index: -1;
    }

    .bam-interferer__content {
      padding: 2rem 1rem;
      grid-area: 1/-1;

      @include tablet() {
        padding: 2.5rem;
      }

      @include desktop() {
        padding: 80px 3rem 40px;
        height: 256px;
      }

      @include high-definition{
        padding: 80px 80px 40px;
      }
    }
  }

  bal-shape {
    position: absolute;
    bottom: -44px;
    right: 1rem;

    @include tablet() {
      bottom: -80px;
      right: 2.5rem;
    }
    @include desktop() {
      top: -132px;
      right: 3rem;
    }

    @include from(1464px) {
      right: calc(((100vw - 1400px) / 2) + 3rem);
    }
  }

  // -------- Image Version -------- //
  &.bam-interferer--is-image {
    padding: 0 1rem;

    @include tablet {
      padding: 0 2rem;
    }

    @include desktop() {
      padding: 0;
    }

    .bam-interferer__image-wrapper {
      display: flex;
      justify-content: center;
      width: 100%;
      padding: 20px;
      border-radius: 0.75rem;
      box-shadow: 0 0 10px 0 rgba(0, 7, 57, 0.15);

      @include desktop() {
        justify-content: flex-end;
        margin-right: 3rem;
        padding: 0;
        border-radius: 0;
        box-shadow: none;
      }

      @include from(1464px) {
        margin-right: calc((100vw - 1336px) / 2);
      }
    }

    .bam-interferer__image {

      bam-image img{
        height: 160px;
        max-width: 160px;
        object-fit: contain;
        object-position: right;

        @include tablet() {
          height: 200px;
          max-width: 200px;
        }
      }
    }
  }

  // -------- Compact Link Version -------- /
  &--is-compact {
    height: auto;

    .bam-interferer__card {
      width: calc(100% - 1rem);
      max-width: 380px;
      position: relative;
      margin-left: auto;
      bottom: unset;
      top: -20px;

      @include tablet() {
        width: 50%;
        max-width: unset;
        top: -48px;
      }
      @include desktop() {
        top: -80px;
      }
    }
  }
}
